import axios from '../../axios/index.js';

export default {
    /**
     * Retrieves orders by autocomplete search term.
     *
     * @param projectId project id
     * @param searchTerm Search term
     *
     * @returns {*}
     */
    getAutocompleteOrdersBySearchTerm (projectId, searchTerm) {
        return axios.get('/api/v1/orders/autocomplete', {
            params: {
                projectId: projectId,
                term: searchTerm,
            },
        });
    },

    /**
     * Retrieves order by given ID.
     *
     * @param id order ID
     *
     * @returns {*}
     */
    getOrder (id) {
        return axios.get('/api/v1/orders/' + id);
    },

    /**
     * Retrieves production shop drawings for order by given ID.
     *
     * @param id Order ID
     *
     * @returns {*}
     */
    getOrderProductionShopDrawings (id) {
        return axios.get('/api/v1/orders/production-shop-drawings/' + id);
    },
};
